export default {
  pending_approval: 'Pending Approval',
  advisor: 'Advisor',
  started: 'Started',
  prequalified: 'Prequalified',
  conditionally_approved: 'Conditionally Approved',
  customer_forms_uploaded: 'Customer Forms Uploaded',
  '4506t_results_uploaded': '4506T Results Uploaded',
  ready_for_etran: 'Ready for ETRAN',
  etran_verified: 'ETRAN Verified',
  forms_to_be_verified: 'Forms to be Verified',
  forms_verified: 'Forms Verified',
  credit_memo_entered: 'Credit Memo Entered',
  loandoc_generated: 'Loandoc Generated',
  loandoc_completed: 'Loandoc Completed',
  loandoc_customer_received_need_signatures: 'Loandoc Need Signatures',
  signatures_checked_and_uploaded: 'Signatures Checked and Uploaded',
  boarded: 'Boarded',
  funded: 'Funded',
  pending_declined: 'Pending Decline',
  declined: 'Declined',
  withdrawn: 'Withdrawn',
  expired: 'Expired'
}